import Button from '@mui/material/Button';
import TuneIcon from '@mui/icons-material/Tune';
import { memo, ReactElement } from 'react';

export interface ShowFilterButtonProps {
  onClick: () => void;
}

export const ShowFilterButton = memo(function ({ onClick }: ShowFilterButtonProps): ReactElement {
  return (
    <Button variant='contained' onClick={onClick} sx={{ borderRadius: '0.5rem' }}>
      <TuneIcon sx={{ mr: 1 }} />
      Filter
    </Button>
  );
});
